import React from "react";

const chevron = (
  <svg
    className="tower-chevron"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    aria-hidden="true"
  >
    <path d="m6 9 6 6 6-6" />
  </svg>
);

// Sección plegable de Monitoreo (una zona, el depósito, lo sin cerrar, lo
// por revisar): encabezado con nombre, aclaración y métricas a la derecha.
export default function TowerSection({
  id,
  className,
  open,
  onToggle,
  title,
  subtitle,
  help,
  metrics,
  children,
}: {
  id?: string;
  className: string;
  open: boolean;
  onToggle: (open: boolean) => void;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  // Explicación al pasar el mouse por el encabezado.
  help?: string;
  metrics: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <details
      id={id}
      className={`tower-zone ${className}`}
      open={open}
      onToggle={(event) => {
        const isOpen = event.currentTarget.open;
        if (isOpen !== open) onToggle(isOpen);
      }}
    >
      <summary title={help}>
        <div className="tower-zone-identity">
          <strong>
            <span className="tower-zone-dot" />
            {title}
          </strong>
          {subtitle && <small className="tower-muted">{subtitle}</small>}
        </div>
        <div className="tower-zone-metrics">
          {metrics}
          {chevron}
        </div>
      </summary>
      {children}
    </details>
  );
}
